"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.PaginationLoadMoreButton = exports.LinearProgress = exports.InfoText = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    maxWidth: 650,
    margin: theme.spacing(0, 'auto')
  }
}));
const InfoText = exports.InfoText = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  marginBottom: theme.spacing(3)
}));
const LinearProgress = exports.LinearProgress = (0, _mui.styled)(_mui.LinearProgress, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['isButtonVisible'])
})(({
  isButtonVisible,
  theme
}) => ({
  height: '8px',
  marginBottom: isButtonVisible ? theme.spacing(6) : 0,
  width: '100%'
}));
const PaginationLoadMoreButton = exports.PaginationLoadMoreButton = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    width: 'unset'
  }
}));
